// @ts-nocheck
import React, { useState } from 'react';
import './MyAccountModal.css';
import ProfileSettings from './ProfileSettings';
import BillingSubscription from './BillingSubscription';
import SecuritySettings from './SecuritySettings';
import Partners from './Partners';
import BrokerConnectionModal from './Partners/BrokerConnectionModal';
import RetailerConnectionModal from './Partners/RetailerConnectionModal';

interface MyAccountModalProps {
  onClose: () => void;
}

type TakeoverType = 'brokers' | 'retailers' | null;

const MyAccountModal = ({ onClose }: MyAccountModalProps) => {
  const [activeSection, setActiveSection] = useState<string | null>(null);
  const [takeover, setTakeover] = useState<TakeoverType>(null);

  const handleSectionClick = (section: string) => setActiveSection(section);
  const handleBack = () => setActiveSection(null);

  // === Takeover rendering (child partner modals) ===
  if (takeover === 'brokers') {
    return (
      <BrokerConnectionModal
        isOpen={true}
        onClose={() => {
          setTakeover(null);
          setActiveSection('Partners'); // restore Partners section view
        }}
        authId={undefined /* your Partners view passes auth via its own context; safe to leave undefined or wire your useAuth here */}
      />
    );
  }

  if (takeover === 'retailers') {
    return (
      <RetailerConnectionModal
        isOpen={true}
        onClose={() => {
          setTakeover(null);
          setActiveSection('Partners');
        }}
        authId={undefined}
      />
    );
  }

  return (
    <div className="my-account-modal-overlay" onClick={onClose}>
      <div className="my-account-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="my-account-modal-header">
          <h2 className="my-account-modal-title">
            {activeSection ? 'My Account – ' : 'My Account'}
            {activeSection && activeSection}
          </h2>
          <button className="my-account-modal-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="my-account-modal-content">
          {!activeSection && (
            <>
              <p className="my-account-intro">
                Manage your account settings, billing, security, and partner connections.
              </p>

              <div className="my-account-sections">
                <div
                  className="my-account-section"
                  onClick={() => handleSectionClick('Profile Settings')}
                >
                  <h3>Profile Settings</h3>
                  <p>Manage your profile information</p>
                </div>

                <div
                  className="my-account-section"
                  onClick={() => handleSectionClick('Billing & Subscription')}
                >
                  <h3>Billing & Subscription</h3>
                  <p>View billing information and manage subscription</p>
                </div>

                <div
                  className="my-account-section"
                  onClick={() => handleSectionClick('Security')}
                >
                  <h3>Security</h3>
                  <p>Change password</p>
                </div>

                <div
                  className="my-account-section"
                  onClick={() => handleSectionClick('Partners')}
                >
                  <h3>Partners</h3>
                  <ul className="my-account-partner-list">
                    <li>Your Brokers</li>
                    <li>Your Retailers</li>
                  </ul>
                </div>
              </div>
            </>
          )}

          {activeSection === 'Profile Settings' && (
            <ProfileSettings onBack={handleBack} />
          )}
          {activeSection === 'Billing & Subscription' && (
            <BillingSubscription onBack={handleBack} />
          )}
          {activeSection === 'Security' && <SecuritySettings onBack={handleBack} />}

          {activeSection === 'Partners' && (
            <Partners
              onBack={handleBack}
              onOpenSubmodal={(which: TakeoverType) => {
                // Take over the screen with the child modal
                setTakeover(which);
              }}
            />
          )}
        </div>

        {/* Footer */}
        {!activeSection && (
          <div className="my-account-modal-footer">
            <button className="my-account-close-btn" onClick={onClose}>
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyAccountModal;
